import React,{ useState,useEffect} from 'react';
import { Grid,Divider} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

import { Button } from '../../../../../Shared';
import {adminUserService} from '../../../../../../services';
import {
    GridContainer,
    GridItem,
    LicenseImage
} from './styled'

function RegisterHealthFacilityNotification(props){
    const ACCEPTED = "accepted";
    const REJECTED = "rejected";

    const { t } = useTranslation();

    const [image, setImage] = useState();
    const [info, setInfo] = useState(props);

    const handleAccept = () => {
        adminUserService.updateRegisterState(info._id,ACCEPTED)
        .then((response) => setInfo(response));
        adminUserService.createHealthFacility(info);
    };

    const handleReject = () => {
        adminUserService.updateRegisterState(info._id,REJECTED)
        .then((response) => setInfo(response));
    };

    useEffect(() => {
        adminUserService.getLicenseImage(info.license_img)
          .then((response) =>
            setImage(Buffer.from(response, "binary").toString("base64"))
          );
      }, []);

    return (
        <GridContainer container direction='row' justify='center' spacing={2} >
            <Grid xs={12}>
                <Divider />
            </Grid>
            <Grid container item xs={12}>
                <GridItem item xs={2}>
                    {t('healthFacilityName')}
                </GridItem>
                <GridItem item xs={10}>
                    {info.name}
                </GridItem>
            </Grid>
            <Grid xs={12}>
                <Divider />
            </Grid>
            <Grid container item xs={12}>
                <GridItem item xs={2}>
                    {t('address')}
                </GridItem>
                <GridItem item xs={10}>
                    {info.address}
                </GridItem>
            </Grid>
            <Grid xs={12}>
                <Divider />
            </Grid>
            <Grid container item xs={12}>
                <GridItem item xs={2}>
                    {t('workTime')}
                </GridItem>
                <GridItem item xs={10}>
                    {info.work_time}
                </GridItem>
            </Grid>
            <Grid xs={12}>
                <Divider />
            </Grid>
            <Grid container item xs={12}>
                <GridItem item xs={2}>
                    {t('specialisation')}
                </GridItem>
                <GridItem item xs={10}>
                    {info.specialisation.toString()}
                </GridItem>
            </Grid>
            <Grid xs={12}>
                <Divider />
            </Grid>
            <Grid container item xs={12}>
                <GridItem item xs={2}>
                    {t('service')}
                </GridItem>
                <GridItem item xs={10}>
                    {info.service}
                </GridItem>
            </Grid>
            <Grid xs={12}>
                <Divider />
            </Grid>
            <Grid container item xs={12}>
                <GridItem item xs={2}>
                    {t('phoneNumber')}
                </GridItem>
                <GridItem item xs={10}>
                    {info.phone_number}
                </GridItem>
            </Grid>
            <Grid xs={12}>
                <Divider />
            </Grid>
            <Grid xs={12}>
                <Divider />
            </Grid>
            <Grid container item xs={12}>
                <GridItem item xs={2}>
                    {t('license')}
                </GridItem>
                <GridItem item xs={10}>
                    <LicenseImage src={`data:image/jpeg;charset=utf-8;base64,${image}`} />
                </GridItem>
            </Grid>
            <Grid container item xs={12} justify="flex-end">
                <Button 
                    variant='contained'
                    color='primary' 
                    style={{ marginRight: 16 }}
                    onClick={handleAccept}>
                        {t('accept')}
                </Button>
                <Button 
                    variant='contained'
                    color='primary' 
                    onClick={handleReject}>
                        {t('reject')}
                </Button>
            </Grid>
        </GridContainer>
    );
}

export default RegisterHealthFacilityNotification;